<template>
    <div class="row clearfix">
        <div v-if="loading" class="loading"></div>
        <div v-if="messageStatus" class="alert alert-success" role="alert">
            {{ messageStatus }}
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="">
                <div class="header">
                    <h2>Пользователи</h2>
                    <router-link tag="a" :to="'/admin/users/add'" class="btn btn-info waves-effect m-t-15"
                                 style="margin: 15px 0">Добавить
                    </router-link>
                </div>
                <div class="body table-responsive">
                    <table class="table table-bordered table-striped js-table dataTable order-table">
                        <thead>
                        <tr>
                            <th>ID</th>
                            <th>Имя</th>
                            <th>E-mail</th>
                            <th>Номер</th>
                            <th>Компания</th>
                            <th>Роль</th>
                            <th>Опции</th>
                            <th>Дата посещения</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in items" :key="index">
                            <td>{{ item.id }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.email }}</td>
                            <td>{{ item.phone }}</td>
                            <td>{{ item.company }}</td>
                            <td>{{ item.role }}</td>
                            <td>
                                <button class="btn btn-danger" @click="execWarning(item.id, index)">Удалить</button>
                                <router-link tag="button" class="btn btn-success" :to="{name: 'AdminUserEdit', params: {id: item.id}}">Изменить</router-link>
                                <router-link tag="button" class="btn btn-primary" :to="{name: 'changePassword', params: {id: item.id}}">Изменить пароль</router-link>
                            </td>
                            <td>{{ item.history }}
                                <br>
                                <router-link tag="button" class="btn mt-1 btn-primary" :to="{name: 'historyUser', params: {id: item.id}}">История посещения</router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const Swal = require('sweetalert2');

    export default {
        name: "AdminUsers",
        props: ['message'],
        data() {
            return {
                items: [],
                messageStatus: null,
                loading: false
            }
        },

        mounted() {
            this.messageStatus = this.message
            this.loading = true

            this.axios
                .get(this.axios.defaults.baseURL + 'admin/users')
                .then(response => {
                    this.items = response.data.users;
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false
            })
        },

        methods: {

            execWarning(id, index){
                Swal.fire({
                    title: 'Точно хотите удалить пользователя?',
                    text: "После удаление вы не можете восстановить!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'Отменить',
                    confirmButtonText: 'Удалить!'
                }).then((result) => {
                    if (result.value) {
                        this.destroy(id, index);
                    }
                })
            },

            destroy(id, index) {
                this.axios
                    .delete(this.axios.defaults.baseURL + 'admin/users/' + id)
                    .then(response => {
                        if (response.data.message === 'success') {
                            this.items.splice(index, 1);
                            this.messageStatus = 'Успешно удален';
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/admin/users/Index.vue